module.exports = __webpack_public_path__ + "static/media/ReportNavIcon.7d9227c3.svg";